import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Nav, Tab, Button, Badge, Alert, Spinner, Form, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createVehicle } from '../services/vehicleService';
import { useAuth } from '../context/AuthContext';
import { FaCar, FaCog, FaMoneyBillWave, FaFileAlt, FaClipboardList, FaCalculator, FaSave, FaTimes, FaCheckCircle, FaShieldAlt, FaExclamationTriangle } from 'react-icons/fa';
import api from '../services/api';

// MODÜLER Form Components
import VehicleBasicInfoForm from '../components/forms/VehicleBasicInfoForm';
import VehiclePriceForm from '../components/forms/VehiclePriceForm';
import TrafficInsuranceForm from '../components/forms/TrafficInsuranceForm';

// YENİ Components
import ExpenseAddForm from '../components/forms/ExpenseAddForm';

import { getBrands, getModelsByBrand } from '../services/vehicleDataService';
import useOCR from '../hooks/useOCR';



// ✅ 8 VEHICLE DOCUMENT CATEGORIES - Satış Faturası + Ekspertiz Raporu eklendi
const VEHICLE_DOCUMENT_CATEGORIES = [
    { category: 'ruhsat', name: 'Ruhsat', required: false, icon: '📄', color: 'warning', bgColor: 'border-warning' },
    { category: 'alis_sozlesmesi', name: 'Alış Sözleşmesi', required: false, icon: '📝', color: 'success', bgColor: 'border-success' },
    { category: 'satis_sozlesmesi', name: 'Satış Sözleşmesi', required: false, icon: '📋', color: 'primary', bgColor: 'border-primary' },
    { category: 'trafik_sigortasi', name: 'Trafik Sigortası Poliçesi', required: false, icon: '🛡️', color: 'info', bgColor: 'border-info' },
    { category: 'sigorta_iptal_policesi', name: 'Sigorta İptal Poliçesi', required: false, icon: '🔴', color: 'danger', bgColor: 'border-danger' },
    { category: 'alis_faturasi', name: 'Alış Faturası', required: false, icon: '🔎', color: 'secondary', bgColor: 'border-secondary' },
    { category: 'satis_faturasi', name: 'Satış Faturası', required: false, icon: '💰', color: 'success', bgColor: 'border-success' },
    { category: 'ekspertiz_raporu', name: 'Ekspertiz Raporu', required: false, icon: '🔧', color: 'warning', bgColor: 'border-warning' }
];


// *** YENİ: OCR Enabled Categories ***
const OCR_ENABLED_CATEGORIES = ['alis_sozlesmesi', 'satis_sozlesmesi', 'alis_faturasi'];

// ENUM MAPPING FUNCTIONS
const mapFuelTypeToBackend = (frontendValue) => {
    if (!frontendValue || frontendValue.trim() === '') return undefined; // ✅ Fix
    const mapping = {
        'Benzin': 'benzin', 'Dizel': 'dizel', 'Hibrit': 'hibrit',
        'Elektrik': 'elektrik', 'LPG': 'lpg', 'Benzin+LPG': 'benzin+lpg'
    };
    return mapping[frontendValue] || frontendValue.toLowerCase();
};

const mapTransmissionToBackend = (frontendValue) => {
    if (!frontendValue || frontendValue.trim() === '') return undefined; // ✅ Fix
    const mapping = {
        'Manuel': 'manuel', 'Otomatik': 'otomatik', 'Yarı Otomatik': 'yarı otomatik'
    };
    return mapping[frontendValue] || frontendValue.toLowerCase();
};

const mapBodyTypeToBackend = (frontendValue) => {
    if (!frontendValue || frontendValue.trim() === '') return undefined; // ✅ Fix
    const mapping = {
        'Sedan': 'sedan', 'Hatchback': 'hatchback', 'SUV': 'suv', 'Coupe': 'coupe',
        'Convertible': 'cabriolet', 'Station Wagon': 'station wagon', 'Pickup': 'pickup', 'Minivan': 'minivan'
    };
    return mapping[frontendValue] || frontendValue.toLowerCase();
};

const AddVehiclePage = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const { processDocument, getExtractedData, getFieldHighlightClass, processing: ocrProcessing } = useOCR();


    // TAB STATE
    const [activeTab, setActiveTab] = useState('documents');

    // *** YENI: Re-acquisition states ***
    const [reacquisitionData, setReacquisitionData] = useState(null);
    const [showReacquisitionModal, setShowReacquisitionModal] = useState(false);
    const [reacquiring, setReacquiring] = useState(false);

    // FORM STATE MANAGEMENT 
    const [formData, setFormData] = useState({
        // Temel Bilgiler
        title: '', brand: '', model: '', bodyType: '', year: '', mileage: '', color: '',
        fuelType: '', transmission: '', description: '',


        // Fiyat Bilgileri
        purchasePrice: '', salePrice: '',
        purchaseDate: new Date().toISOString().split('T')[0], saleDate: '',

        // Kişi Bilgileri
        purchasedFrom: { name: 'Stok Girişi', phone: '', email: '', address: '', idNumber: '' },
        soldTo: { name: '', phone: '', email: '', address: '', idNumber: '' },

        // Yasal Bilgiler
        plateNumber: '', chassisNumber: '',
        hasTramer: false, tramerAmount: 0, tramerDescription: '',

        // Trafik Sigortası
        trafficInsurance: {
            startDate: '',
            endDate: '',
            insuranceAmount: 0,
            refundAmount: 0,
            paymentCardName: ''
        },

        // Sistem Bilgileri
        location: { city: currentUser?.address?.city || '', district: currentUser?.address?.district || '' },
        status: 'active',

         // ✅ Expertiz Bilgileri
        expertizData: {},
        expertizNotes: '',


        // ✅ YENİ: Technical Details
        technicalDetails: {
            engineDisplacement: '',
            horsepower: '',
            warrantyStatus: '',
            inspectionDate: '',
            sahibindenUrl: '',
            labelDescription: ''
        }
    });

    // YENİ STATE'LER
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [addedExpenses, setAddedExpenses] = useState([]);



    // ✅ YENİ: Özel belge upload için
    const fileInputRef = useRef(null);
    const [currentUploadCategory, setCurrentUploadCategory] = useState(null);

    // UI STATE
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0, step: '' });

    // brand model states
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);
    const [brandsLoading, setBrandsLoading] = useState(false);
    const [modelsLoading, setModelsLoading] = useState(false);

    // *** YENİ: Supplier search state'leri ***
    const [searchingSupplier, setSearchingSupplier] = useState(false);
    const [foundSupplier, setFoundSupplier] = useState(null);
    const [supplierSearchError, setSupplierSearchError] = useState('');
    const [identityType, setIdentityType] = useState('TCKN');

    // *** YENİ: Customer search state'leri ***
    const [searchingCustomer, setSearchingCustomer] = useState(false);
    const [foundCustomer, setFoundCustomer] = useState(null);
    const [customerSearchError, setCustomerSearchError] = useState('');
    const [customerIdentityType, setCustomerIdentityType] = useState('TCKN');

    // *** YENİ: OCR States ***
    const [ocrStatus, setOcrStatus] = useState({ processing: false, completed: 0, total: 0, message: '' });
    const [ocrFields, setOcrFields] = useState(new Set());

    // TAB NAVIGATION 
    const tabs = [
        { key: 'documents', title: 'Belgeler', icon: FaClipboardList, color: 'purple' },

        { key: 'basic', title: 'Temel Bilgiler', icon: FaCar, color: 'primary' },
        { key: 'price', title: 'Fiyat', icon: FaMoneyBillWave, color: 'success' },
        { key: 'insurance', title: 'Trafik Sigortası', icon: FaShieldAlt, color: 'info' },
       
        { key: 'expenses', title: 'Masraflar', icon: FaCalculator, color: 'danger' }
    ];


    // useEffect'i ekle:
    useEffect(() => {
        const loadBrands = async () => {
            try {
                setBrandsLoading(true);
                const response = await getBrands();
                if (response.success) {
                    setBrands(response.data || []);
                }
            } catch (error) {
                console.error('Brands load error:', error);
            } finally {
                setBrandsLoading(false);
            }
        };

        loadBrands();
    }, []);

    useEffect(() => {
        const loadModels = async () => {
            if (!formData.brand) {
                setModels([]);
                return;
            }

            try {
                setModelsLoading(true);
                const response = await getModelsByBrand(formData.brand);
                if (response.success) {
                    setModels(response.data || []);
                }
            } catch (error) {
                console.error('Models load error:', error);
                setModels([]);
            } finally {
                setModelsLoading(false);
            }
        };

        loadModels();
    }, [formData.brand]);

    // ✅ YENİ: ReportGenerator pattern'ini kopyala
    const handleDocumentUpload = async (file, category, vehicleId) => {
        try {
            const formData = new FormData();
            formData.append('document', file);
            formData.append('category', category);
            formData.append('title', `${category} - Vehicle ${vehicleId}`);
            formData.append('vehicleId', vehicleId); // Vehicle'a bağla
            formData.append('notes', `Araç belgesi - ${formData.title || formData.brand} ${formData.model}`);

            console.log(`📄 Uploading document: ${category} for vehicle ${vehicleId}`);

            const response = await api.post('/documents/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                console.log(`✅ Document uploaded: ${category}`);
                return response.data.document;
            } else {
                throw new Error(response.data.message || 'Document upload failed');
            }
        } catch (error) {
            console.error(`❌ Document upload error for ${category}:`, error);
            throw error;
        }
    };

    // Şu handler'ları ekle:
    const handleBrandChange = (e) => {
        const brand = e.target.value;
        setFormData(prev => ({
            ...prev,
            brand: brand,
            model: '',
            title: brand || ''
        }));
    };

    const handleModelChange = (e) => {
        const model = e.target.value;
        setFormData(prev => ({
            ...prev,
            model: model,
            title: `${prev.brand} ${model}`.trim()
        }));
    };

    // ✅ YENİ: Özel belge upload handler'ları
    const handleSpecialDocumentUpload = (category) => {
        setCurrentUploadCategory(category);
        fileInputRef.current?.click();
    };

    const handleFileInputChange = async (e) => {
        const file = e.target.files[0];
        if (!file || !currentUploadCategory) return;

        // Dosya boyutu kontrolü (5MB)
        if (file.size > 5 * 1024 * 1024) {
            setError('Dosya boyutu 5MB\'dan büyük olamaz');
            return;
        }

        // Dosya türü kontrolü
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
            setError('Sadece PDF, JPG, PNG dosyaları kabul edilir');
            return;
        }

        // uploadedDocuments'e ekle
        const newDocument = {
            file: file,
            category: currentUploadCategory,
            name: file.name,
            size: file.size,
            type: file.type,
            uploadDate: new Date().toISOString()
        };

        setUploadedDocuments(prev => {
            // Aynı kategorideki eski dosyaları kaldır
            const filtered = prev.filter(doc => doc.category !== currentUploadCategory);
            // Yeni dosyayı ekle
            return [...filtered, newDocument];
        });

        // ✅ YENİ: Kategori ismini doğru göster
        const categoryName = getCategoryDisplayName(currentUploadCategory);
        setSuccessMessage(`${categoryName} belgesi güncellendi: ${file.name}`);
        setTimeout(() => setSuccessMessage(''), 3000);


        // ✅ DEBUG: OCR trigger kontrolü
        console.log('🔥 ADD PAGE OCR DEBUG:', {
            currentUploadCategory: currentUploadCategory,
            OCR_ENABLED_CATEGORIES: OCR_ENABLED_CATEGORIES,
            isOCREnabled: OCR_ENABLED_CATEGORIES.includes(currentUploadCategory),
            fileName: file.name
        });

        // ✅ YENİ: OCR İşlemi + Enhanced Notification
        if (OCR_ENABLED_CATEGORIES.includes(currentUploadCategory)) {
            console.log(`🔍 OCR processing for category: ${currentUploadCategory}`);

            setOcrStatus({ processing: true, completed: 0, total: 1, message: `${getCategoryDisplayName(currentUploadCategory)} belgesi okunuyor...` });

            try {
                const result = await processDocument(file, currentUploadCategory);

                if (result.success) {
                    // ✅ FIX: result'tan direkt mapped data kullan
                    if (result.mappedData && Object.keys(result.mappedData).length > 0) {
                        // Create proper data structure for handleOCRDataExtracted
                        const extractedData = { [result.documentType]: result.mappedData };

                        // ✅ FIX: Generate proper mapped fields from result
                        let mappedFields = [];
                        if (result.mappedData) {
                            // Extract field names from mapped data structure
                            Object.keys(result.mappedData).forEach(key => {
                                if (key === 'purchasedFrom' || key === 'soldTo') {
                                    // Handle nested objects
                                    Object.keys(result.mappedData[key]).forEach(subKey => {
                                        mappedFields.push(`${key}.${subKey}`);
                                    });
                                } else {
                                    // Handle direct fields
                                    mappedFields.push(key);
                                }
                            });
                        }

                        await handleOCRDataExtracted(extractedData, mappedFields);

                        // ✅ YENİ: Enhanced success notification
                        const ocrMessage = getOCRSuccessMessage(currentUploadCategory, result.fieldsExtracted || 0);
                        setSuccessMessage(ocrMessage);
                        setTimeout(() => setSuccessMessage(''), 5000);
                    } else {
                        // No OCR data found
                        setSuccessMessage(`${categoryName} belgesi yüklendi ancak OCR verileri çıkarılamadı. Manuel kontrol edin.`);
                        setTimeout(() => setSuccessMessage(''), 4000);
                    }
                }
            } catch (error) {
                console.error('❌ OCR processing failed:', error);
                setOcrStatus({ processing: false, completed: 0, total: 0, message: '⚠️ OCR okuma başarısız, manuel kontrol edin' });
                setSuccessMessage(`${categoryName} belgesi yüklendi ancak OCR başarısız. Manuel kontrol edin.`);
                setTimeout(() => setSuccessMessage(''), 4000);
            }
        }

        // Cleanup - delay için timeout ekle
        setTimeout(() => {
            setCurrentUploadCategory(null);
            if (e.target) {
                e.target.value = ''; // Reset input
            }
        }, 100);
    };

    // ✅ YENİ: Kategori display name helper
    const getCategoryDisplayName = (category) => {
        const categoryMap = VEHICLE_DOCUMENT_CATEGORIES.find(cat => cat.category === category);
        return categoryMap ? categoryMap.name : category;
    };

    // ✅ YENİ: OCR Success Message Helper
    const getOCRSuccessMessage = (categoryId, fieldCount) => {
        switch (categoryId) {
            case 'ruhsat':
            case 'alis_sozlesmesi':
                return `🎉 Alış sözleşmesi analiz edildi!\n✅ Satıcı bilgileri otomatik dolduruldu.\n📊 ${fieldCount} alan güncellendi. Sarı işaretli alanları kontrol edin.`;
            case 'satis_sozlesmesi':
                return `🎉 Satış sözleşmesi analiz edildi!\n✅ Alıcı bilgileri otomatik dolduruldu.\n📊 ${fieldCount} alan güncellendi. Sarı işaretli alanları kontrol edin.`;
            default:
                return `🎉 Belge analiz edildi!\n✅ ${fieldCount} alan otomatik dolduruldu. Sarı işaretli alanları kontrol edin.`;
        }
    };

    // *** YENİ: TCKN/VKN ile supplier arama fonksiyonu ***
    const handleSearchSupplier = async () => {
        if (!formData.purchasedFrom?.idNumber || formData.purchasedFrom.idNumber.length < 10) {
            setSupplierSearchError('Geçerli bir kimlik numarası giriniz');
            return;
        }

        // *** YENİ: Search öncesi bilgileri temizle ***
        setFormData(prev => ({
            ...prev,
            purchasedFrom: {
                ...prev.purchasedFrom,
                name: '',
                phone: '',
                email: '',
                address: ''
                // idNumber aynı kalır
            }
        }));

        setSearchingSupplier(true);
        setSupplierSearchError('');
        setError('');
        setSuccessMessage('');

        try {
            console.log(`👤 Supplier aranıyor: ${formData.purchasedFrom.idNumber} (${identityType})`);

            const response = await api.get(`/customers/search/${formData.purchasedFrom.idNumber}`);

            if (response.data.success && response.data.customers.length > 0) {
                const supplier = response.data.customers[0];
                setFoundSupplier(supplier);

                // Supplier bilgilerini otomatik doldur
                setFormData(prev => ({
                    ...prev,
                    purchasedFrom: {
                        name: supplier.name || prev.purchasedFrom.name,
                        phone: supplier.phone || prev.purchasedFrom.phone,
                        email: supplier.email || prev.purchasedFrom.email,
                        address: supplier.address || prev.purchasedFrom.address,
                        idNumber: supplier.identifierNumber || prev.purchasedFrom.idNumber
                    }
                }));

                setSuccessMessage(`✅ ${supplier.name} tedarikçisi bulundu ve bilgiler otomatik dolduruldu!`);
                console.log('✅ Supplier bulundu ve form dolduruldu:', supplier);

            } else {
                setSupplierSearchError('Bu kimlik numarasına ait tedarikçi bulunamadı');
                setFoundSupplier(null);
            }

        } catch (error) {
            console.error('Supplier arama hatası:', error);

            if (error.response?.status === 404) {
                setSupplierSearchError('Bu kimlik numarasına ait tedarikçi bulunamadı');
            } else if (error.response?.status === 403) {
                setSupplierSearchError('Bu işlem için yetkiniz bulunmuyor');
            } else {
                setSupplierSearchError('Tedarikçi aranırken hata oluştu. Lütfen tekrar deneyin.');
            }

            setFoundSupplier(null);
        } finally {
            setSearchingSupplier(false);
        }
    };

    // *** YENİ: TCKN/VKN ile customer arama fonksiyonu ***
    const handleSearchCustomer = async () => {
        if (!formData.soldTo?.idNumber || formData.soldTo.idNumber.length < 10) {
            setCustomerSearchError('Geçerli bir kimlik numarası giriniz');
            return;
        }

        // *** YENİ: Search öncesi bilgileri temizle ***
        setFormData(prev => ({
            ...prev,
            soldTo: {
                ...prev.soldTo,
                name: '',
                phone: '',
                email: '',
                address: ''
                // idNumber aynı kalır
            }
        }));

        setSearchingCustomer(true);
        setCustomerSearchError('');
        setError('');
        setSuccessMessage('');

        try {
            console.log(`👤 Customer aranıyor: ${formData.soldTo.idNumber} (${customerIdentityType})`);

            const response = await api.get(`/customers/search/${formData.soldTo.idNumber}`);

            if (response.data.success && response.data.customers.length > 0) {
                const customer = response.data.customers[0];
                setFoundCustomer(customer);

                // Customer bilgilerini otomatik doldur
                setFormData(prev => ({
                    ...prev,
                    soldTo: {
                        name: customer.name || prev.soldTo.name,
                        phone: customer.phone || prev.soldTo.phone,
                        email: customer.email || prev.soldTo.email,
                        address: customer.address || prev.soldTo.address,
                        idNumber: customer.identifierNumber || prev.soldTo.idNumber
                    }
                }));

                setSuccessMessage(`✅ ${customer.name} müşterisi bulundu ve bilgiler otomatik dolduruldu!`);
                console.log('✅ Customer bulundu ve form dolduruldu:', customer);

            } else {
                setCustomerSearchError('Bu kimlik numarasına ait müşteri bulunamadı');
                setFoundCustomer(null);
            }

        } catch (error) {
            console.error('Customer arama hatası:', error);

            if (error.response?.status === 404) {
                setCustomerSearchError('Bu kimlik numarasına ait müşteri bulunamadı');
            } else if (error.response?.status === 403) {
                setCustomerSearchError('Bu işlem için yetkiniz bulunmuyor');
            } else {
                setCustomerSearchError('Müşteri aranırken hata oluştu. Lütfen tekrar deneyin.');
            }

            setFoundCustomer(null);
        } finally {
            setSearchingCustomer(false);
        }
    };

    // *** YENİ: OCR Data Handler ***
    const handleOCRDataExtracted = async (extractedData, mappedFields) => {
        console.log('🎯 OCR data received:', extractedData, mappedFields);

        setOcrStatus({ processing: true, completed: 0, total: Object.keys(extractedData).length, message: 'OCR verileri forma uygulanıyor...' });

        let updatedFormData = { ...formData };
        let appliedFields = 0;

        // Apply OCR data to form
        Object.entries(extractedData).forEach(([docType, data]) => {
            Object.entries(data).forEach(([key, value]) => {
                if (key.includes('.')) {
                    // Nested objects (purchasedFrom.name, soldTo.name, technicalDetails.engineDisplacement)
                    const [parent, child] = key.split('.');
                    if (!updatedFormData[parent]) updatedFormData[parent] = {};
                    updatedFormData[parent][child] = value;
                } else {
                    // Direct fields
                    updatedFormData[key] = value;
                }
                appliedFields++;
            });
        });

        // Update form data
        setFormData(updatedFormData);

        //  Track OCR fields for highlighting - ADD to existing, don't replace
        setOcrFields(prev => {
            const newSet = new Set(prev);
            mappedFields.forEach(field => newSet.add(field));
            console.log('🎯 Updated OCR fields:', Array.from(newSet));
            return newSet;
        });
        // Update status
        setOcrStatus({ processing: false, completed: appliedFields, total: appliedFields, message: `✅ ${appliedFields} alan otomatik dolduruldu` });

        // Success message
        setSuccessMessage(`🎉 OCR tamamlandı!\n${appliedFields} alan otomatik forma uygulandı.\nSarı işaretli alanları kontrol edin.`);
        setTimeout(() => setSuccessMessage(''), 5000);
    };

    // MEVCUT handleChange function'ını bul, şunu ekle:
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked }));
            return;
        }

        // ✅ SADECE BU BLOGU EKLE:
        if (name === 'technicalDetails') {
            setFormData(prev => ({ ...prev, technicalDetails: value }));
            return;
        }

        // Nested object handling (trafficInsurance.field)
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData(prev => ({
                ...prev,
                [parent]: { ...prev[parent], [child]: value }
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };


    // ✅ VALIDATION: Enhanced form validation
    const validateForm = () => {
        const errors = [];

        // Temel bilgiler - ZORUNLU ALANLAR
        if (!formData.title?.trim()) errors.push('İlan başlığı gerekli');
        if (!formData.brand?.trim()) errors.push('Marka gerekli');
        if (!formData.model?.trim()) errors.push('Model gerekli');
        if (!formData.year || isNaN(formData.year)) errors.push('Geçerli model yılı gerekli');
        if (!formData.purchasePrice || isNaN(formData.purchasePrice)) errors.push('Geçerli alış fiyatı gerekli');

        // Yasal bilgiler
        if (!formData.plateNumber?.trim()) errors.push('Plaka numarası gerekli');
        if (!formData.chassisNumber?.trim()) errors.push('Şase numarası gerekli');
        if (formData.chassisNumber && formData.chassisNumber.length !== 17) {
            errors.push('Şase numarası 17 karakter olmalıdır');
        }

        // Plaka format kontrolü
        if (formData.plateNumber && !/^[0-9]{2}\s?[A-Z]{1,3}\s?[0-9]{1,4}$/i.test(formData.plateNumber)) {
            errors.push('Geçersiz plaka formatı');
        }

        // Tramer validasyonu
        if (formData.hasTramer) {
            if (!formData.tramerAmount || formData.tramerAmount <= 0) {
                errors.push('Tramer varsa tutar girilmelidir');
            }
            if (!formData.tramerDescription?.trim()) {
                errors.push('Tramer varsa açıklama girilmelidir');
            }
        }

        // purchasedFrom validation
        if (!formData.purchasedFrom?.name?.trim() || formData.purchasedFrom.name.trim().length < 2) {
            errors.push('Satıcı adı en az 2 karakter olmalıdır');
        }

        if (!formData.purchasedFrom?.idNumber?.trim()) {
            errors.push('Satıcı T.C./Vergi numarası gerekli');
        }

        // ✅ NEW: Technical details validation
        if (formData.technicalDetails) {
            const td = formData.technicalDetails;
            if (td.engineDisplacement && (td.engineDisplacement < 0 || td.engineDisplacement > 10000)) {
                errors.push('Motor hacmi 0-10000 cc arasında olmalıdır');
            }
            if (td.horsepower && (td.horsepower < 0 || td.horsepower > 2000)) {
                errors.push('Motor gücü 0-2000 kW arasında olmalıdır');
            }
        }

        console.log('🔍 Validation result:', errors.length > 0 ? errors : '✅ All valid');
        return errors;
    };

    // ✅ TAB VALIDATION - Her tab için completion durumu
    const getTabCompletionStatus = () => {
        const status = {
            basic: !!(formData.title?.trim() && formData.brand?.trim() && formData.model?.trim() && formData.year && formData.plateNumber?.trim() && formData.chassisNumber?.trim()),
            price: !!(formData.purchasePrice && formData.purchasedFrom?.name?.trim() && formData.purchasedFrom?.idNumber?.trim()),
            insurance: !!(formData.trafficInsurance.insuranceAmount > 0 && formData.trafficInsurance.paymentCardName?.trim()),

            // ✅ Documents artık zorunlu değil, ama en az 2 kategori olsun önerelim
            documents: getRequiredDocuments() >= 2,
            expenses: true
        };

        return status;
    };

    // ✅ YENİ: 2-Step Submit Process
    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError('');
        setSuccessMessage('');
        setUploadProgress({ current: 1, total: uploadedDocuments.length + 2, step: 'Araç bilgileri kaydediliyor...' });

        try {
            // Validation
            const validationErrors = validateForm();
            if (validationErrors.length > 0) {
                setError('Form hataları: ' + validationErrors.join(', '));
                setLoading(false);
                return;
            }

            // purchasedFrom.name güvenli atama
            const safePurchasedFromName = formData.purchasedFrom?.name?.trim() || 'Stok Girişi';
            if (safePurchasedFromName.length < 2) {
                setFormData(prev => ({
                    ...prev,
                    purchasedFrom: {
                        ...prev.purchasedFrom,
                        name: 'Stok Girişi'
                    }
                }));
            }

            // ✅ STEP 1: Vehicle data preparation (WITHOUT documents)
            setUploadProgress({ current: 1, total: uploadedDocuments.length + 2, step: 'Araç bilgileri kaydediliyor...' });

            const vehicleData = {
                // Temel bilgiler
                title: formData.title,
                brand: formData.brand,
                model: formData.model,
                bodyType: mapBodyTypeToBackend(formData.bodyType),
                year: Number(formData.year),
                mileage: Number(formData.mileage) || 0,
                color: formData.color || '',
                fuelType: mapFuelTypeToBackend(formData.fuelType),
                transmission: mapTransmissionToBackend(formData.transmission),
                description: formData.description,

                // Fiyat bilgileri
                purchasePrice: Number(formData.purchasePrice),
                salePrice: formData.salePrice && formData.salePrice.trim() !== '' ? Number(formData.salePrice) : null,
                purchaseDate: formData.purchaseDate,
                saleDate: formData.saleDate && formData.saleDate.trim() !== '' ? formData.saleDate : null,

                // Kişi bilgileri
                purchasedFrom: {
                    ...formData.purchasedFrom,
                    name: safePurchasedFromName
                },
                soldTo: formData.soldTo?.name ? formData.soldTo : null,

                // Yasal bilgiler
                plateNumber: formData.plateNumber.toUpperCase(),
                chassisNumber: formData.chassisNumber.toUpperCase(),
                hasTramer: formData.hasTramer,
                tramerAmount: Number(formData.tramerAmount) || 0,
                tramerDescription: formData.tramerDescription || '',

                // Sistem bilgileri
                location: formData.location,
                status: 'active',

                // ✅ Expertiz Bilgileri
                expertizData: formData.expertizData || {},
                expertizNotes: formData.expertizNotes || '',

                // ✅ CRITICAL FIX: Technical Details
                technicalDetails: formData.technicalDetails || {},

                // Masraflar
                expenses: addedExpenses,

                // Trafik sigortası
                trafficInsurance: formData.trafficInsurance,

                // ERP bilgileri
                addedBy: currentUser._id
            };

            console.log("🔍 FRONTEND DEBUG - FINAL vehicleData:", vehicleData);
            console.log("🔍 TECHNICAL DETAILS FRONTEND:", vehicleData.technicalDetails);


            // ✅ CRITICAL FIX: FormData oluştur ve tüm alanları append et
            const submitFormData = new FormData();

            // ✅ TEMEL ALANLAR - Her birini ayrı ayrı append et
            submitFormData.append('title', vehicleData.title || '');
            submitFormData.append('brand', vehicleData.brand || '');
            submitFormData.append('model', vehicleData.model || '');
            submitFormData.append('year', vehicleData.year?.toString() || '');
            submitFormData.append('purchasePrice', vehicleData.purchasePrice?.toString() || '');

            // ✅ OPTIONAL FIELDS - undefined kontrolü ile
            if (vehicleData.bodyType && vehicleData.bodyType !== 'undefined') {
                submitFormData.append('bodyType', vehicleData.bodyType);
            }
            if (vehicleData.fuelType && vehicleData.fuelType !== 'undefined') {
                submitFormData.append('fuelType', vehicleData.fuelType);
            }
            if (vehicleData.transmission && vehicleData.transmission !== 'undefined') {
                submitFormData.append('transmission', vehicleData.transmission);
            }

            submitFormData.append('mileage', vehicleData.mileage?.toString() || '0');
            submitFormData.append('color', vehicleData.color || '');
            submitFormData.append('description', vehicleData.description || '');

            // ✅ FIYAT BİLGİLERİ
            if (vehicleData.salePrice) {
                submitFormData.append('salePrice', vehicleData.salePrice.toString());
            }
            if (vehicleData.saleDate) {
                submitFormData.append('saleDate', vehicleData.saleDate);
            }
            submitFormData.append('purchaseDate', vehicleData.purchaseDate);

            // ✅ KİŞİ BİLGİLERİ - JSON olarak
            submitFormData.append('purchasedFrom', JSON.stringify(vehicleData.purchasedFrom));
            if (vehicleData.soldTo) {
                submitFormData.append('soldTo', JSON.stringify(vehicleData.soldTo));
            }

            // ✅ YASAL BİLGİLER
            submitFormData.append('plateNumber', vehicleData.plateNumber);
            submitFormData.append('chassisNumber', vehicleData.chassisNumber);
            submitFormData.append('hasTramer', vehicleData.hasTramer.toString());
            submitFormData.append('tramerAmount', vehicleData.tramerAmount.toString());
            submitFormData.append('tramerDescription', vehicleData.tramerDescription);

            // ✅ CRITICAL FIX: Technical Details - JSON string olarak
            if (vehicleData.technicalDetails && Object.keys(vehicleData.technicalDetails).length > 0) {
                submitFormData.append('technicalDetails', JSON.stringify(vehicleData.technicalDetails));
                console.log('✅ technicalDetails appended:', JSON.stringify(vehicleData.technicalDetails));
            }

            // ✅ EXPERTİZ BİLGİLERİ - JSON string olarak
            if (vehicleData.expertizData && Object.keys(vehicleData.expertizData).length > 0) {
                submitFormData.append('expertizData', JSON.stringify(vehicleData.expertizData));
            }
            if (vehicleData.expertizNotes) {
                submitFormData.append('expertizNotes', vehicleData.expertizNotes);
            }

            // ✅ TRAFİK SİGORTASI
            if (vehicleData.trafficInsurance) {
                submitFormData.append('trafficInsurance', JSON.stringify(vehicleData.trafficInsurance));
            }

            // ✅ MASRAFLAR
            if (vehicleData.expenses && vehicleData.expenses.length > 0) {
                submitFormData.append('expenses', JSON.stringify(vehicleData.expenses));
            }

            // ✅ SİSTEM BİLGİLERİ
            submitFormData.append('status', vehicleData.status);
            submitFormData.append('addedBy', vehicleData.addedBy);

            // ✅ DEBUG: FormData içeriğini kontrol et
            console.log("🔍 FORMDATA CONTENTS:");
            for (let [key, value] of submitFormData.entries()) {
                if (['title', 'brand', 'model', 'year', 'purchasePrice', 'technicalDetails'].includes(key)) {
                    console.log(`${key}: ${value} (type: ${typeof value})`);
                }
            }

            console.log('🚀 Step 1: Creating vehicle without documents...');

            // ✅ DEBUG: Frontend form data kontrolü
            console.log("🔍 FRONTEND formData.salePrice:", formData.salePrice);
            console.log("🔍 FRONTEND formData.saleDate:", formData.saleDate);
            console.log("🔍 FRONTEND vehicleData.salePrice:", vehicleData.salePrice);
            console.log("🔍 FRONTEND vehicleData.saleDate:", vehicleData.saleDate);

            console.log("🔍 FORMDATA CONTENTS:");
            for (let [key, value] of submitFormData.entries()) {
                if (key === 'technicalDetails') {
                    console.log(`${key}: ${value}`);
                }
            }

            // ✅ EKSPERTİZ DEBUG LOG'U
            console.log("🔍 Expertiz Data:", {
                expertizData: vehicleData.expertizData,
                expertizNotes: vehicleData.expertizNotes
            });


            // ✅ DEBUG: FormData içeriğini kontrol et
            console.log("🔍 FORMDATA CONTENTS:");
            for (let [key, value] of submitFormData.entries()) {
                if (key === 'salePrice' || key === 'saleDate') {
                    console.log(`${key}: ${value} (type: ${typeof value})`);
                }
            }

            console.log('🚀 Step 1: Creating vehicle without documents...');

            // ✅ STEP 1: Create vehicle
            const vehicleResult = await createVehicle(submitFormData);

            if (!vehicleResult.success) {
                // ✅ Re-acquisition check
                if (vehicleResult.action === 'reacquisition_available') {
                    setReacquisitionData(vehicleResult);
                    setShowReacquisitionModal(true);
                    setLoading(false);
                    return;
                }

                throw new Error(vehicleResult.message || 'Araç oluşturulamadı');
            }

            if (!vehicleResult.vehicle || !vehicleResult.vehicle._id) {
                throw new Error('Araç bilgileri eksik');
            }

            const vehicleId = vehicleResult.vehicle._id;
            console.log('✅ Step 1 completed: Vehicle created with ID:', vehicleId);

            // ✅ STEP 2: Upload documents separately (ReportGenerator pattern)
            if (uploadedDocuments.length > 0) {
                console.log(`🚀 Step 2: Uploading ${uploadedDocuments.length} documents...`);

                const uploadedDocs = [];
                const uploadErrors = [];

                for (let i = 0; i < uploadedDocuments.length; i++) {
                    const doc = uploadedDocuments[i];

                    setUploadProgress({
                        current: i + 2,
                        total: uploadedDocuments.length + 2,
                        step: `Belge yükleniyor: ${doc.category} (${i + 1}/${uploadedDocuments.length})`
                    });

                    try {
                        if (doc.file) {
                            const uploadedDoc = await handleDocumentUpload(doc.file, doc.category, vehicleId);
                            uploadedDocs.push(uploadedDoc);
                            console.log(`✅ Document ${i + 1}/${uploadedDocuments.length} uploaded: ${doc.category}`);
                        }
                    } catch (docError) {
                        console.error(`❌ Document upload failed for ${doc.category}:`, docError);
                        uploadErrors.push({
                            category: doc.category,
                            error: docError.message
                        });
                    }
                }

                console.log(`✅ Step 2 completed: ${uploadedDocs.length}/${uploadedDocuments.length} documents uploaded`);

                if (uploadErrors.length > 0) {
                    console.warn('⚠️ Some documents failed to upload:', uploadErrors);
                    setError(`Bazı belgeler yüklenemedi: ${uploadErrors.map(e => e.category).join(', ')}`);
                }
            }

            // ✅ STEP 3: Success
            setUploadProgress({
                current: uploadedDocuments.length + 2,
                total: uploadedDocuments.length + 2,
                step: 'Tamamlandı!'
            });

            setSuccessMessage(
                `🎉 Araç başarıyla stoka eklendi!\n` +
                `📄 ${uploadedDocuments.length} belge yüklendi (${getRequiredDocuments()} kategori)\n` +
                `💰 ${addedExpenses.length} masraf kaydedildi`
            );

            console.log('🎉 All steps completed successfully!');

            // Detay sayfasına yönlendir
            setTimeout(() => {
                navigate(`/vehicles/${vehicleId}`);
            }, 2000);

        } catch (error) {
            console.error('❌ Submit error:', error);

            // ✅ DEBUG: Error response'unu detaylı incele
            console.log('🔍 ERROR DEBUG:', {
                hasResponse: !!error.response,
                responseData: error.response?.data,
                action: error.response?.data?.action,
                statusCode: error.response?.status
            });

            // ✅ YENİ: Re-acquisition handling
            if (error.response?.data?.action === 'reacquisition_available') {
                console.log('🎯 REACQUISITION ACTION DETECTED!');
                setReacquisitionData(error.response.data);
                setShowReacquisitionModal(true);
                setLoading(false);
                return;
            }

            // Mevcut error handling
            if (error.response?.data) {
                console.error('🔍 Server Error Details:', error.response.data);
                console.error('🔍 Validation Errors:', error.response.data.details);
            }

            setError(error.response?.data?.message || error.message || 'Sunucu hatası');
        } finally {
            setLoading(false);
        }
    };

    // *** YENI: Re-acquisition handler ***
    const handleReacquisition = async () => {
        if (!reacquisitionData?.existingVehicle?.id) return;

        setReacquiring(true);
        setError('');

        try {
            const reacquireData = {
                plateNumber: formData.plateNumber,
                purchasePrice: formData.purchasePrice,
                purchaseDate: formData.purchaseDate,
                purchasedFrom: formData.purchasedFrom,
                mileage: formData.mileage,
                color: formData.color
            };

            console.log('🔄 Re-acquiring vehicle:', reacquisitionData.existingVehicle.id);

            const response = await api.post(`/vehicles/${reacquisitionData.existingVehicle.id}/reacquire`, reacquireData);

            if (response.data.success) {
                const vehicleId = reacquisitionData.existingVehicle.id;

                // ✅ BELGELER YÜKLE
                if (uploadedDocuments.length > 0) {
                    console.log(`🚀 Uploading ${uploadedDocuments.length} documents...`);

                    for (let i = 0; i < uploadedDocuments.length; i++) {
                        const doc = uploadedDocuments[i];
                        try {
                            if (doc.file) {
                                await handleDocumentUpload(doc.file, doc.category, vehicleId);
                            }
                        } catch (docError) {
                            console.error(`❌ Document upload failed:`, docError);
                        }
                    }
                }

                setSuccessMessage(`🎉 Araç ve ${uploadedDocuments.length} belge başarıyla yüklendi!`);
                setShowReacquisitionModal(false);

                setTimeout(() => {
                    navigate(`/vehicles/${reacquisitionData.existingVehicle.id}`);
                }, 2000);
            } else {
                throw new Error(response.data.message || 'Re-acquisition failed');
            }

        } catch (error) {
            console.error('Re-acquisition error:', error);
            setError(error.response?.data?.message || error.message || 'Araç tekrar alınırken hata oluştu');
        } finally {
            setReacquiring(false);
        }
    };

    // HESAPLAMA FONKSİYONLARI
    const getTotalExpenses = () => {
        return addedExpenses.reduce((total, exp) => total + exp.amount, 0);
    };

    // ✅ YENİ: 6 kategoriye göre güncellendi
    const getRequiredDocuments = () => {
        // 6 kategoriden kaç tanesinde belge var
        return VEHICLE_DOCUMENT_CATEGORIES.filter(cat =>
            uploadedDocuments.some(doc => doc.category === cat.category)
        ).length;
    };

    const tabStatus = getTabCompletionStatus();

    return (
        <Container className="py-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h1 className="mb-1">🚗 Yeni Araç Stoka Ekle</h1>
                    <p className="text-muted mb-0">
                        Araç bilgilerini tamamlayarak stoka ekleyin
                    </p>
                </div>
                <div className="d-flex gap-2">
                    <Button
                        variant="outline-secondary"
                        onClick={() => navigate('/vehicles')}
                        disabled={loading}
                    >
                        <FaTimes className="me-1" />
                        İptal
                    </Button>
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={handleSubmit}
                        disabled={loading || !tabStatus.basic || !tabStatus.price}
                    >
                        {loading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                {uploadProgress.step || 'Stoka Ekleniyor...'}
                            </>
                        ) : (
                            <>
                                <FaSave className="me-1" />
                                Stoka Ekle
                            </>
                        )}
                    </Button>
                </div>
            </div>

            {/* Alert Messages */}
            {error && <Alert variant="danger">{error}</Alert>}
            {successMessage && <Alert variant="success" style={{ whiteSpace: 'pre-line' }}>{successMessage}</Alert>}

            {/* Progress Bar */}
            {loading && uploadProgress.total > 0 && (
                <Alert variant="info" className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span>{uploadProgress.step}</span>
                        <span>{uploadProgress.current}/{uploadProgress.total}</span>
                    </div>
                    <div className="progress">
                        <div
                            className="progress-bar"
                            style={{ width: `${(uploadProgress.current / uploadProgress.total) * 100}%` }}
                        ></div>
                    </div>
                </Alert>
            )}

            <Row>
                <Col lg={8}>
                    {/* TAB NAVIGATION */}
                    <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
                        <Card className="mb-4">
                            <Card.Header className="p-0">
                                <Nav variant="tabs" className="border-0">
                                    {tabs.map(tab => {
                                        const IconComponent = tab.icon;
                                        const isCompleted = tabStatus[tab.key];

                                        return (
                                            <Nav.Item key={tab.key}>
                                                <Nav.Link
                                                    eventKey={tab.key}
                                                    className={`d-flex align-items-center px-3 py-3 ${activeTab === tab.key ? 'active' : ''
                                                        }`}
                                                >
                                                    <IconComponent
                                                        className={`me-2 text-${tab.color}`}
                                                        size={16}
                                                    />
                                                    <span className="fw-bold">{tab.title}</span>
                                                    {isCompleted && (
                                                        <Badge bg="success" className="ms-2">✓</Badge>
                                                    )}
                                                </Nav.Link>
                                            </Nav.Item>
                                        );
                                    })}
                                </Nav>
                            </Card.Header>

                            <Card.Body className="p-4">
                                <Tab.Content>
                                    <Tab.Pane eventKey="basic">
                                        
                                        {/* Diğer form alanları VehicleBasicInfoForm'dan gelsin */}
                                        <VehicleBasicInfoForm
                                            data={formData}
                                            handleChange={handleChange}
                                            getFieldHighlightClass={getFieldHighlightClass}
                                        />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="price">
                                        <VehiclePriceForm
                                            data={formData}
                                            handleChange={handleChange}
                                            getFieldHighlightClass={getFieldHighlightClass}
                                            // *** Supplier props ***
                                            identityType={identityType}
                                            setIdentityType={setIdentityType}
                                            searchingSupplier={searchingSupplier}
                                            foundSupplier={foundSupplier}
                                            supplierSearchError={supplierSearchError}
                                            handleSearchSupplier={handleSearchSupplier}
                                            // *** YENİ: Customer props ***
                                            customerIdentityType={customerIdentityType}
                                            setCustomerIdentityType={setCustomerIdentityType}
                                            searchingCustomer={searchingCustomer}
                                            foundCustomer={foundCustomer}
                                            customerSearchError={customerSearchError}
                                            handleSearchCustomer={handleSearchCustomer}
                                            setFormData={setFormData}
                                        />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="insurance">
                                        <TrafficInsuranceForm
                                            data={formData}
                                            handleChange={handleChange}
                                            onFileUpload={(file, category) => {
                                                // Dosya yükleme işlemi
                                                console.log('Sigorta belgesi yükleniyor:', file, category);
                                                // uploadedDocuments'e ekle
                                                setUploadedDocuments(prev => [...prev, { file, category }]);
                                            }}
                                            mode="add"
                                        />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="documents">
                                        <div className="mb-4">
                                            <h6 className="mb-3">📄 Araç Belgeleri</h6>
                                            <p className="text-muted mb-4">
                                                Gerekli evrakları kategorilere göre yükleyin. Eksik belgeler daha sonra düzenleme sayfasından eklenebilir.
                                            </p>

                                                <Row className="g-3">
                                                    {VEHICLE_DOCUMENT_CATEGORIES.map(cat => {
                                                        const uploadedForCategory = uploadedDocuments.filter(d => d.category === cat.category);

                                                        return (
                                                            <Col md={6} lg={4} key={cat.category}>
                                                                <Card className={`h-100 ${cat.bgColor} border-2`}>
                                                                    <Card.Body className="text-center p-4">
                                                                        <div className="mb-3">
                                                                            <span style={{ fontSize: '2rem' }}>{cat.icon}</span>
                                                                        </div>
                                                                        <h6 className="fw-bold mb-2">{cat.name}</h6>
                                                                        <Badge bg="secondary" className="mb-3">
                                                                            {uploadedForCategory.length} belge
                                                                        </Badge>

                                                                        {/* Upload edilen dosyaları göster */}
                                                                        {uploadedForCategory.length > 0 && (
                                                                            <div className="mb-3">
                                                                                {uploadedForCategory.map((doc, index) => (
                                                                                    <div key={index} className="text-start mb-1">
                                                                                        <small className="text-muted d-block">
                                                                                            📎 {doc.name}
                                                                                        </small>
                                                                                        <small className="text-success">
                                                                                            ✓ {new Date(doc.uploadDate).toLocaleDateString('tr-TR')}
                                                                                        </small>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}

                                                                        <div>
                                                                            <Button
                                                                                variant={cat.color}
                                                                                size="sm"
                                                                                onClick={() => handleSpecialDocumentUpload(cat.category)}
                                                                                disabled={loading}
                                                                            >
                                                                                {uploadedForCategory.length > 0 ? '🔄 Değiştir' : '📎 Yükle'}
                                                                            </Button>
                                                                        </div>

                                                                        {/* Remove uploaded document option */}
                                                                        {uploadedForCategory.length > 0 && (
                                                                            <div className="mt-2">
                                                                                <Button
                                                                                    variant="outline-danger"
                                                                                    size="sm"
                                                                                    onClick={() => {
                                                                                        setUploadedDocuments(prev =>
                                                                                            prev.filter(doc => doc.category !== cat.category)
                                                                                        );
                                                                                        setSuccessMessage(`${cat.name} belgesi kaldırıldı`);
                                                                                        setTimeout(() => setSuccessMessage(''), 3000);
                                                                                    }}
                                                                                    disabled={loading}
                                                                                >
                                                                                    🗑️ Kaldır
                                                                                </Button>
                                                                            </div>
                                                                        )}
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                            )

                                            {/* Progress Bar */}
                                            <div className="mt-4">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className="fw-bold">Belge Yükleme İlerlemesi</span>
                                                    <span className="text-muted">
                                                        {uploadedDocuments.length} / {VEHICLE_DOCUMENT_CATEGORIES.length} kategori
                                                    </span>
                                                </div>
                                                <div className="progress" style={{ height: '8px' }}>
                                                    <div
                                                        className="progress-bar bg-primary"
                                                        style={{
                                                            width: `${(VEHICLE_DOCUMENT_CATEGORIES
                                                                .filter(cat => uploadedDocuments.some(doc => doc.category === cat.category)).length
                                                                / VEHICLE_DOCUMENT_CATEGORIES.length) * 100}%`
                                                        }}
                                                    ></div>
                                                </div>
                                                <small className="text-muted">
                                                    {VEHICLE_DOCUMENT_CATEGORIES.filter(cat =>
                                                        uploadedDocuments.some(doc => doc.category === cat.category)
                                                    ).length} kategori tamamlandı
                                                </small>
                                            </div>

                                            {/* Info Alert */}
                                            {uploadedDocuments.length > 0 && (
                                                <Alert variant="info" className="mt-3">
                                                    <FaCheckCircle className="me-2" />
                                                    <strong>📌 Bilgi:</strong> Belgeler araç kaydedilirken yüklenecek.
                                                    Eksik belgeler daha sonra düzenleme sayfasından eklenebilir.
                                                </Alert>
                                            )}

                                            {/* No documents alert */}
                                            {uploadedDocuments.length === 0 && (
                                                <Alert variant="warning" className="mt-3">
                                                    <FaExclamationTriangle className="me-2" />
                                                    <strong>⚠️ Uyarı:</strong> Henüz belge yüklenmedi.
                                                    Araç kaydedildikten sonra belgeler düzenleme sayfasından eklenebilir.
                                                </Alert>
                                            )}
                                        </div>

                                        {/* Hidden File Input */}
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleFileInputChange}
                                            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                            style={{ display: 'none' }}
                                        />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="expenses">
                                        <ExpenseAddForm
                                            addedExpenses={addedExpenses}
                                            setAddedExpenses={setAddedExpenses}
                                        />
                                    </Tab.Pane>

                                </Tab.Content>
                            </Card.Body>
                        </Card>
                    </Tab.Container>
                </Col>

                <Col lg={4}>
                    <Card className="mb-4 vehicle-summary-sticky">
                        <Card.Header>
                            <h5 className="mb-0">📋 Araç Özeti</h5>
                        </Card.Header>
                        <Card.Body>
                            {/* Temel Bilgiler */}
                            <div className="mb-3">
                                <h6 className="text-primary">Temel Bilgiler</h6>
                                <div className="small">
                                    <div>Marka: <strong>{formData.brand || 'Seçilmedi'}</strong></div>
                                    <div>Model: <strong>{formData.model || 'Seçilmedi'}</strong></div>
                                    <div>Kasa: <strong>{formData.bodyType || 'Seçilmedi'}</strong></div>
                                    <div>Yıl: <strong>{formData.year || 'Girilmedi'}</strong></div>
                                    <div>Yakıt: <strong>{formData.fuelType}</strong></div>
                                    <div>Vites: <strong>{formData.transmission}</strong></div>
                                </div>
                            </div>

                            {/* Fiyat Bilgileri */}
                            <div className="mb-3">
                                <h6 className="text-success">Fiyat Bilgileri</h6>
                                <div className="small">
                                    <div>Alış Fiyatı: <strong className={!formData.purchasePrice ? 'text-danger' : ''}>{formData.purchasePrice ? `${Number(formData.purchasePrice).toLocaleString()} ₺` : 'Girilmedi'}</strong></div>
                                    <div>Satış Fiyatı: <strong className={!formData.salePrice ? 'text-danger' : ''}>{formData.salePrice ? `${Number(formData.salePrice).toLocaleString()} ₺` : 'Girilmedi'}</strong></div>
                                    {formData.purchasePrice && formData.salePrice && (
                                        <div className="text-success">
                                            Brüt Kar: <strong>{(Number(formData.salePrice) - Number(formData.purchasePrice)).toLocaleString()} ₺</strong>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Yasal Bilgiler */}
                            <div className="mb-3">
                                <h6 className="text-warning">Yasal Bilgiler</h6>
                                <div className="small">
                                    <div>Plaka: <strong>{formData.plateNumber || 'Girilmedi'}</strong></div>
                                    <div>Şase: <strong>{formData.chassisNumber ? `${formData.chassisNumber.substring(0, 8)}...` : 'Girilmedi'}</strong></div>
                                    <div>Tramer: <strong>{formData.hasTramer ? 'Var' : 'Yok'}</strong></div>
                                </div>
                            </div>

                            {/* Trafik Sigortası */}
                            <div className="mb-3">
                                <h6 className="text-info">Trafik Sigortası</h6>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="small">Ödeme Kartı:</span>
                                    <Badge bg="info">{formData.trafficInsurance.paymentCardName || 'Seçilmedi'}</Badge>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="small">Tutar:</span>
                                    <Badge bg="warning">{formData.trafficInsurance.insuranceAmount?.toLocaleString() || '0'} ₺</Badge>
                                </div>
                            </div>

                            {/* Belgeler - Enhanced */}
                            <div className="mb-3">
                                <h6 style={{ color: '#6f42c1' }}>Belgeler</h6>

                                {/* Kategori bazlı durum */}
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="small">Toplam Kategori:</span>
                                    <Badge bg={getRequiredDocuments() >= 3 ? 'success' : getRequiredDocuments() >= 1 ? 'warning' : 'secondary'}>
                                        {getRequiredDocuments()} / {VEHICLE_DOCUMENT_CATEGORIES.length}
                                    </Badge>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="small">Toplam Belge:</span>
                                    <Badge bg={uploadedDocuments.length >= 3 ? 'success' : uploadedDocuments.length >= 1 ? 'warning' : 'secondary'}>
                                        {uploadedDocuments.length}
                                    </Badge>
                                </div>

                                {/* Kategori detayları */}
                                {getRequiredDocuments() > 0 && (
                                    <div className="mt-2">
                                        <small className="text-muted d-block mb-1">Yüklenen kategoriler:</small>
                                        {VEHICLE_DOCUMENT_CATEGORIES
                                            .filter(cat => uploadedDocuments.some(doc => doc.category === cat.category))
                                            .map(cat => (
                                                <div key={cat.category} className="d-flex justify-content-between align-items-center">
                                                    <small className="text-muted">{cat.icon} {cat.name}:</small>
                                                    <Badge bg="success" className="small">
                                                        {uploadedDocuments.filter(doc => doc.category === cat.category).length}
                                                    </Badge>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )}

                                {/* Progress bar */}
                                <div className="mt-2">
                                    <div className="progress" style={{ height: '4px' }}>
                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${(getRequiredDocuments() / VEHICLE_DOCUMENT_CATEGORIES.length) * 100}%`,
                                                backgroundColor: '#6f42c1'
                                            }}
                                        ></div>
                                    </div>
                                    <small className="text-muted">
                                        %{Math.round((getRequiredDocuments() / VEHICLE_DOCUMENT_CATEGORIES.length) * 100)} tamamlandı
                                    </small>
                                </div>
                            </div>

                            {/* Masraflar */}
                            <div className="mb-3">
                                <h6 className="text-danger">Masraflar</h6>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="small">Masraf Sayısı:</span>
                                    <Badge bg="info">{addedExpenses.length}</Badge>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="small">Toplam Tutar:</span>
                                    <Badge bg="danger">{getTotalExpenses().toLocaleString()} ₺</Badge>
                                </div>
                            </div>

                            {/* Satıcı Bilgisi */}
                            <div className="mb-3">
                                <h6 className="text-info">Satıcı</h6>
                                <div className="small">
                                    <strong>{formData.purchasedFrom?.name || 'Stok Girişi'}</strong>
                                    {formData.purchasedFrom?.phone && (
                                        <div>{formData.purchasedFrom.phone}</div>
                                    )}
                                </div>
                            </div>

                            {/* Progress */}
                            <div className="mb-3">
                                <h6>Tamamlanma Durumu</h6>
                                <div className="progress mb-2">
                                    <div
                                        className="progress-bar bg-success"
                                        style={{
                                            width: `${(Object.values(tabStatus).filter(Boolean).length / Object.keys(tabStatus).length) * 100}%`
                                        }}
                                    ></div>
                                </div>
                                <small className="text-muted">
                                    {Object.values(tabStatus).filter(Boolean).length}/{Object.keys(tabStatus).length} adım tamamlandı
                                </small>
                            </div>

                            {/* Action Buttons */}
                            <div className="d-grid gap-2">
                                <Button
                                    variant="primary"
                                    size="lg"
                                    onClick={handleSubmit}
                                    disabled={loading || !tabStatus.basic || !tabStatus.price}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            {uploadProgress.step || 'Kaydediliyor...'}
                                        </>
                                    ) : (
                                        <>
                                            <FaSave className="me-2" />
                                            Stoka Ekle
                                        </>
                                    )}
                                </Button>

                                <Button
                                    variant="outline-secondary"
                                    onClick={() => navigate('/vehicles')}
                                    disabled={loading}
                                >
                                    <FaTimes className="me-1" />
                                    İptal
                                </Button>
                            </div>

                            {/* Upload Progress Detail */}
                            {loading && uploadProgress.total > 0 && (
                                <div className="mt-3 p-2 bg-primary bg-opacity-10 rounded">
                                    <small>
                                        <strong>İşlem Durumu:</strong><br />
                                        {uploadProgress.step}<br />
                                        <span className="text-muted">
                                            {uploadProgress.current}/{uploadProgress.total} tamamlandı
                                        </span>

                                        {/* Belge upload durumu */}
                                        {uploadProgress.step?.includes('Belge') && (
                                            <div className="mt-1">
                                                <small className="text-info">
                                                    📄 {uploadedDocuments.length} belge, {getRequiredDocuments()} kategori yüklenecek
                                                </small>
                                            </div>
                                        )}
                                    </small>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {/* Re-acquisition Modal */}
            {showReacquisitionModal && reacquisitionData && (
                <Modal show={showReacquisitionModal} onHide={() => setShowReacquisitionModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Araç Tekrar Alımı</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert variant="info">
                            <h6>Bu araç daha önce stoğunuzda vardı!</h6>
                            <p className="mb-0">{reacquisitionData.message}</p>
                        </Alert>

                        {reacquisitionData.existingVehicle && (
                            <Card className="mb-3">
                                <Card.Header>
                                    <h6 className="mb-0">Mevcut Araç Bilgileri</h6>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={6}>
                                            <p><strong>Marka:</strong> {reacquisitionData.existingVehicle.brand}</p>
                                            <p><strong>Model:</strong> {reacquisitionData.existingVehicle.model}</p>
                                            <p><strong>Yıl:</strong> {reacquisitionData.existingVehicle.year}</p>
                                        </Col>
                                        <Col md={6}>
                                            <p><strong>Plaka:</strong> {reacquisitionData.existingVehicle.plateNumber}</p>
                                            <p><strong>Son Satış:</strong> {new Date(reacquisitionData.existingVehicle.lastSaleDate).toLocaleDateString('tr-TR')}</p>
                                            <p><strong>Son Fiyat:</strong> {reacquisitionData.existingVehicle.lastSalePrice?.toLocaleString()} ₺</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowReacquisitionModal(false)} disabled={reacquiring}>
                            Hayır, İptal Et
                        </Button>
                        <Button variant="primary" onClick={handleReacquisition} disabled={reacquiring}>
                            {reacquiring ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Yeni Period Başlatılıyor...
                                </>
                            ) : (
                                'Evet, Yeni Sahiplik Dönemi Başlat.'
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </Container>
    );
};

export default AddVehiclePage;